import { showLoading, hideLoading } from './loading';
export default {
    showLoading (type, text, callback){
        showLoading(type, text, callback);
    },
    hideLoading (){
        hideLoading();
    }
}
